import styled, { keyframes } from 'styled-components';
import { ComposerBar } from '../chatSurfaces.styled';

/** The bar that replaces the composer while a voice message is being recorded. */

const pulse = keyframes`
  0%, 100% { transform: scaleY(0.4); }
  50% { transform: scaleY(1); }
`;

/**
 * The recorder trims the bar's usual 16px left gutter to 4px: that gutter is
 * there to give the message placeholder room to breathe, and here the same
 * red circle as the voice player sits in it.
 *
 * Centred, unlike the composer it inherits from. That one is bottom-aligned so
 * its icons stay level with the last line as the draft grows - there is no
 * growing textarea here, so flex-end just dropped the 24px waveform and the
 * timer to the bottom of the 32px button beside them.
 */
export const RecorderBar = styled(ComposerBar)`
  padding-left: 4px;
  align-items: center;
`;

/* 32px, like every other control in the bar - at 40px it was the one thing
   forcing the composer taller than the 40px it is meant to be. */
export const RecordButton = styled.button`
  flex: none;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  background: ${({ theme }) => theme.primary};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    display: block;
    width: 12px;
    height: 12px;
  }
`;

export const Waveform = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 24px;
`;

export const Bar = styled.span<{ $index: number }>`
  flex: none;
  width: 3px;
  height: 100%;
  border-radius: 2px;
  background: ${({ theme }) => theme.primary};
  animation: ${pulse} 1s ease-in-out infinite;
  /* The delay repeats every 14 bars, so the wave travels across the full width
     instead of drifting further out of phase the wider the bar gets. */
  animation-delay: ${({ $index }) => ($index % 14) * 0.07}s;
`;

export const Hint = styled.span`
  flex: 1;
  font-size: 14px;
  color: ${({ theme }) => theme.lightGray};
`;

export const Timer = styled.span`
  flex: none;
  font-size: 13px;
  color: ${({ theme }) => theme.darkGray};
`;
